module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_order.a49b404a573ba3796de6f98a6f1f30c4.png";